import { usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { usePrimaryDecisionMakerConnection } from '../../../decisionMakers/hooks/usePrimaryDecisionMakerConnection';

type Result = ModelHookResult<{
	showLegislativeBodies: boolean;
	showDMSection: boolean;
}>;

export function useDecisionMakerSection(): Result {
	const {
		data: { isUserEligibleForLegislativeBodies },
	} = usePetitionDetailsPageUserData();
	const {
		data: { totalCount },
	} = usePrimaryDecisionMakerConnection();

	return {
		data: {
			showLegislativeBodies: isUserEligibleForLegislativeBodies,
			showDMSection: totalCount > 0,
		},
	};
}
